"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecipientSystem = exports.TaxDivSystem = exports.AccountingTypeSystem = exports.AccountingConfigKey = void 0;
exports.AccountingConfigKey = {
    ACCOUNTING_TYPE_SYSTEM: "AccountingTypeSystem",
    TAX_DIV_SYSTEM: "TaxDivSystem",
};
exports.AccountingTypeSystem = {
    DEFAULT: "default",
    CONCUR: "concur",
    COUPA: "coupa",
    UNKNOWN: "unknown",
};
exports.TaxDivSystem = {
    DEFAULT: "default",
    STATIC: "static",
    UNKNOWN: "unknown",
};
exports.RecipientSystem = {
    DEFAULT: "default",
    UNKNOWN: "unknown",
};
